import React, { useState, useEffect } from "react";
import { Layout, Menu, Button } from "antd";
import { Link, Outlet, useLocation } from "react-router-dom";
import {
  DashboardOutlined,
  TagOutlined,
  ShopOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  BarChartOutlined,
  ApartmentOutlined,
} from "@ant-design/icons";

const { Header, Sider, Content } = Layout;

const AdminLayout = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(window.innerWidth < 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    window.location.href = "/admin/login"; ///admin    /project/shoppers/admin
  };

  const handleMenuClick = () => {
    if (isMobile) {
      setCollapsed(true);
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* SIDEBAR */}
      <Sider
        collapsible
        collapsed={collapsed}
        trigger={null} // disable default trigger
        collapsedWidth={isMobile ? 0 : 80}
      >
        <div className="logo logoDash">{collapsed ? "EZ" : "EZWINDS"}</div>

        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          onClick={handleMenuClick}
        >
          <Menu.Item key="/dashboard" icon={<DashboardOutlined />}>
            <Link to="/admin/dashboard">Dashboard</Link>
          </Menu.Item>

          {/* <Menu.Item key="/mode" icon={<TagOutlined />}>
            <Link to="/admin/mode">Promo Ads</Link>
          </Menu.Item> */}

          {/* <Menu.Item key="/ai-menu" icon={<RobotOutlined />}>
            <Link to="/admin/ai-menu">AI Menu Creation</Link>
          </Menu.Item> */}

          <Menu.Item key="/login-as-merchant" icon={<ShopOutlined />}>
            <Link to="/admin/login-as-merchant">Login as Merchant</Link>
          </Menu.Item>

          <Menu.Item key="/manage-admin" icon={<TagOutlined />}>
            <Link to="/admin/manage-admin">Manage Admins</Link>
          </Menu.Item>

          <Menu.Item key="/admin/workflow" icon={<ApartmentOutlined />}>
            <Link to="/admin/workflow">Workflow</Link>
          </Menu.Item>

          <Menu.Item key="/admin/usage" icon={<BarChartOutlined />}>
            <Link to="/admin/usage">Usage</Link>
          </Menu.Item>

          <Menu.Item
            key="logout"
            icon={<LogoutOutlined />}
            onClick={handleLogout}
          >
            Logout
          </Menu.Item>
        </Menu>
      </Sider>

      {/* MAIN LAYOUT */}
      <Layout>
        <Header
          className="headerBg"
          style={{ display: "flex", alignItems: "center" }}
        >
          {/* TOGGLE BUTTON */}
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: "18px", marginRight: "16px" }}
          />

          <h2 className="titles" style={{ margin: 0 }}>
            Admin Panel
          </h2>
        </Header>

        <Content className="contnetWraps">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
